import Courses from "@/pages/authenticated/Courses";
import Welcome from "@/pages/authenticated/Welcome";
import Channels from "@/pages/authenticated/Channels";
import ProfileActivity from "@/pages/authenticated/profile/Activity";
import ProfileChannels from "@/pages/authenticated/profile/Channels";
import ProfileCourses from "@/pages/authenticated/profile/Courses";
import ProfileExternalTraining from "@/pages/authenticated/profile/ExternalTraining";
import Password from "@/pages/authenticated/profile/Password";
import ProfileProfile from "@/pages/authenticated/profile/Profile";
import CoursePlayer from "@/pages/authenticated/courses/CoursePlayer";
import CourseDetails from "@/pages/authenticated/courses/CourseDetails";
import ChannelDetails from "@/pages/authenticated/channels/ChannelDetails";
import ViewCourseTestLogs from "@/pages/authenticated/courses/ViewCourseTestLogs";
import ProfileSummary from "@/pages/authenticated/profile/TeamProfileSummary";
import QuickResources from "@/pages/QuickResources";
import Resources from "@/pages/Resources";
import ResourceCategories from "@/pages/ResourceCategories";

const routes = [
  {
    path: "/courses",
    name: "Admin Courses",
    component: Courses,
    meta: {
      breadcrumb: [
        {
          text: "Courses",
          disabled: true,
          href: "/admin"
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/courses/player/:id",
    name: "Course Player",
    component: CoursePlayer,
    meta: {
      breadcrumb: [
        {
          text: "Courses",
          disabled: false,
          href: "/courses"
        },
        {
          text: "Player",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/courses/details/:id",
    name: "Course Details",
    component: CourseDetails,
    meta: {
      breadcrumb: [
        {
          text: "Courses",
          disabled: false,
          href: "/courses"
        },
        {
          text: "Details",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/playlist/details/:id",
    name: "Playlist Details",
    component: ChannelDetails,
    meta: {
      breadcrumb: [
        {
          text: "Playlists",
          disabled: false,
          href: "/playlists"
        },
        {
          text: "Details",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/welcome",
    name: "Auth Welcome",
    component: Welcome
  },
  {
    path: "/playlists",
    name: "Playlists",
    component: Channels,
    meta: {
      breadcrumb: [
        {
          text: "Playlists",
          disabled: false,
          href: "/playlists"
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/activity",
    name: "Profile Activity",
    component: ProfileActivity,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: false,
          href: "/profile/activity"
        },
        {
          text: "Activity",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/playlists",
    name: "Profile Playlists",
    component: ProfileChannels,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "Playlists",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/courses",
    name: "Profile Courses",
    component: ProfileCourses,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "Courses",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/external-training",
    name: "Profile External Training",
    component: ProfileExternalTraining,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "External Training",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/profile",
    name: "Profile",
    component: ProfileProfile,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "Edit Profile",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/password",
    name: "Profile Change Password",
    component: Password,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "Change Password",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/courses/test/log/:id/:userId",
    name: "Course Test Log",
    component: ViewCourseTestLogs,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: true,
          href: "/profile"
        },
        {
          text: "Change Password",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
    path: "/profile/summary/:id",
    name: "Profile Summary",
    component: ProfileSummary,
    meta: {
      breadcrumb: [
        {
          text: "Profile",
          disabled: false,
          href: "/profile/summary"
        },
        {
          text: "Activity",
          disabled: true
        }
      ],
      public: false,
      admin: false
    }
  },
  {
      path: "/resources",
      name: "resourceCategories",
      component: ResourceCategories,
      meta: {
        breadcrumb: [
          {
            text: "Resource Category",
            disabled: true
          },
        ],
        public: false,
        admin: false
      }
    },
    {
      path: "/resources/:id",
      name: "resource",
      component: Resources,
      meta: {
        breadcrumb: [
          {
            text: "Resource Category",
            disabled: false,
            href: "/resources"
          },
          {
            text: "Resources",
            disabled: true
          }
        ],
        public: false,
        admin: false
      }
    },
    {
        path: "/quick-resources",
        name: "quickResources",
        component: QuickResources,
        meta: {
          breadcrumb: [
            {
              text: "Resource Category",
              disabled: false,
              href: "/resources"
            },
            {
              text: "Quick Resources",
              disabled: true
            }
          ],
          public: false,
          admin: false
        }
      },
];

export default routes;
